export default "__VITE_ASSET__BuqXdlVL__"